import Link from 'next/link';
import styled from 'styled-components';
import {
  EncoreComponentProps,
  NavBarListItem,
  Type,
  spacer16,
} from '@spotify-internal/encore-web';

const StyledAnchorType = styled(Type)`
  &[href]:focus::after {
    inline-size: ${spacer16};
  }

  &::after {
    inline-size: ${spacer16};
  }
`;

const StyledNavBarListItem = styled(NavBarListItem)`
  cursor: pointer;
`;

function NavLink({
  href,
  ...props
}: EncoreComponentProps<typeof Link, typeof Type>) {
  return (
    <Link href={href} passHref legacyBehavior>
      <StyledAnchorType as="a" {...props} />
    </Link>
  );
}

export function NavBarListItemAsLink(
  props: EncoreComponentProps<typeof NavBarListItem, typeof Link>,
) {
  return <StyledNavBarListItem {...props} component={NavLink} />;
}
